module.exports = __webpack_public_path__ + "img/index_style3.30c750ac.jpg";